const Skeleton = ({
  as: Component = "div",
  className = "",
  rounded = "rounded-md",
  ...props
}) => (
  <Component
    aria-hidden="true"
    className={`animate-pulse bg-gray-200/70 ${rounded} ${className}`}
    {...props}
  />
);

export default Skeleton;
